import { c as _c } from "react/compiler-runtime";
import React, { type ReactElement } from 'react';
import BodyDrawer from '@precis-digital/kurama/BodyDrawer';
import { useCopilot } from 'shared/context/CopilotContext';
import { useTranslation } from 'shared/translations';
import CopilotDrawerChatView from './CopilotDrawerChatView';
import CopilotDrawerErrorBoundary from './CopilotDrawerErrorBoundary';
const CopilotDrawer = () => {
  const $ = _c(8);
  const {
    isCopilotOpen,
    closeCopilotDrawer
  } = useCopilot();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "copilot"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("drawerTitle");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CopilotDrawerErrorBoundary><CopilotDrawerChatView /></CopilotDrawerErrorBoundary>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== closeCopilotDrawer || $[5] !== isCopilotOpen || $[6] !== t1) {
    t3 = <BodyDrawer isOpen={isCopilotOpen} onClose={closeCopilotDrawer} title={t1} content={t2} />;
    $[4] = closeCopilotDrawer;
    $[5] = isCopilotOpen;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default CopilotDrawer;